import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  RowVisibility,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import hfbNumbers from "@coworker/app/src/components/InputPopup/UserFiltersRow/hfbNumbers.json";

export const LOCATION_ID = "location";

export const DEFAULT_LOCATION_VALUE: FilterValue = {
  filterId: LOCATION_ID,
  value: "",
};

export function useLocationFilter(): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = DEFAULT_LOCATION_VALUE;

  const hfbs = hfbNumbers.map((hfb) => ({
    value: `depts=${hfb}`,
    title: t(`hfbFilterOptionString`, { hfb }) + " - " + t(`hfb${hfb}String`),
  }));

  return {
    inputType: InputType.Select,
    filterType: FilterType.Filter,
    id: LOCATION_ID,
    title: t("location3String"),
    options: [
      {
        title: t("wholeStoreString"),
        value: "",
      },
      {
        title: t("hfbString"),
        options: hfbs,
      },
    ],
    enabled: true,
    defaultValue,
    rowVisibility: RowVisibility.PillOnly,
  };
}
